export default __webpack_public_path__ + "static/media/folder_p.8aadd7c3.png";